<template>
  <div>
    <p>
      {{ $t('check') }} {{ $t('goToStart') }} <mdicon name="mdi-windows" /> → {{ $t('parameters') }}  <img v-if="image" :src="image" style="width:3%;height:2%;" class="error-image" alt=""> → {{ $t('privacy') }} <mdicon name="mdi-lock-outline" /> → {{ $t('cameraAndSure') }}
    </p>
    <ol>
      <li>
        {{ $t('p1') }}
      </li>
      <li>
        {{ $t('p2') }}
      </li>
      <li>
        {{ $t('p3') }}
      </li>
      <li>
        {{ $t('p4') }}
      </li>
    </ol>
    <br>
    <p>
      {{ $t('more') }} <a target="_blank" href="https://support.microsoft.com/windows/a83257bc-e990-d54a-d212-b5e41beba857">{{ $t('support') }}</a>.
    </p>
  </div>
</template>

<script>
import { mdiLockOutline, mdiWindows } from '@mdi/js';
import cogOutlineImage from '../../../assets/img/cog-outline.png';

export default {
  name: 'NotAllowedBlinkWindowsSystem',
  computed: {
    image() {
      return cogOutlineImage;
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
check: Unable to access your microphone and/or camera. Most likely, access to the microphone/camera is denied in the privacy settings of Windows 10.
goToStart: Go to Start
parameters: Settings
privacy: Privacy
cameraAndSure: Click on Microphone and Camera settings and make sure that your system allows access to both devices.
p1: Microphone/Camera access is enabled for this device;
p2: '"Allow apps to access the microphone" / "Allow applications to access camera" is set to "On";'
p3: '"Allow desktop apps to access microphone" / "Allow desktop apps to access my camera" (if any) is set to "On";'
p4: Refresh the page after making any changes to the settings.
more: Learn more on the
support: Microsoft Support site
</i18n>

<i18n locale="ru" lang="yaml">
check: Невозможно получить доступ к микрофону/камере. Вероятнее всего доступ к микрофону запрещён в настройках конфиденциальности Windows 10.
goToStart: Перейдите Пуск
parameters: Параметры
privacy: Конфиденциальность
cameraAndSure: 'Перейдите в раздел Микрофон, а затем камера и убедитесь, что доступ к устройству не запрещён:'
p1: Доступ к микрофону/камере для этого устройства включен;
p2: «Разрешить приложениям доступ к камере» / «Разрешить приложениям доступ к микрофону» находится в положении «Вкл.»;
p3: «Разрешить классическим приложениям доступ к камере» / «Разрешить классическим приложениям доступ к микрофону» (если есть) находится в положении «Вкл.»;
p4: После внесения изменений в настройки обновите страницу.
more: Подробнее на сайте
support: поддержки Microsoft
</i18n>
